import { pushToDataLayer } from '@/utils/gtm'

export const transformProductName = (name = '') => name.trim().toLowerCase().replace(/ /g, '-')

export const webshopPageEvent = ({ country = '', locale = '', userId = '' }) => pushToDataLayer({
  country, language: locale, userId
})

export const addToCartEvent = (products = []) => {
  const items = products.map(({ slug, productId, price, sizeLabel, quantity, category }) => ({
    item_name: slug,
    item_id: `${productId}`,
    price,
    item_brand: 'ON THAT ASS',
    item_category: category,
    item_variant: sizeLabel,
    quantity
  }))

  return pushToDataLayer({
    event: 'add_to_cart',
    ecommerce: {
      items
    }
  })
}

export const purchaseEvent = ({
  products = [],
  currency = 'EUR',
  value = 0,
  shipping = 0,
  orderBundleId
}) => {
  const items = products.map(({ slug, productId, price, sizeLabel, quantity, category }) => ({
    item_name: slug,
    item_id: `${productId}`,
    price,
    item_brand: 'ON THAT ASS',
    item_category: category,
    item_variant: sizeLabel,
    quantity
  }))

  return pushToDataLayer({
    event: 'purchase',
    ecommerce: {
      currency,
      value,
      shipping,
      transaction_id: orderBundleId,
      items
    }
  })
}
